export default __webpack_public_path__ + "static/media/cpath_logo_white.0a8ca2cf.svg";